module.exports = __webpack_public_path__ + "img/card-image.90b5337a.svg";